/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { WorkflowVersionRetrieve } from "./WorkflowVersionRetrieve"

export type WorkflowGroupRetrieve = {
  readonly uuid: string
  name: string
  /**
   * * `ACTIVE` - Active
   * * `DISABLED` - Disabled
   */
  state?: WorkflowGroupRetrieve.state
  readonly active_version: WorkflowVersionRetrieve
}
export namespace WorkflowGroupRetrieve {
  /**
   * * `ACTIVE` - Active
   * * `DISABLED` - Disabled
   */
  export enum state {
    ACTIVE = "ACTIVE",
    DISABLED = "DISABLED",
  }
}
